import React from "react";

interface WelcomeTemplateProps {
  userName: string;
  loginUrl?: string;
}

const WelcomeTemplate: React.FC<WelcomeTemplateProps> = ({ userName, loginUrl = "#" }) => {
  const templateHTML = `
<!DOCTYPE html>
<html lang="fr">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>Bienvenue sur EventToBee 🐝</title>
    <style>
        body {
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            margin: 0;
            padding: 0;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: #333;
        }
        .container {
            max-width: 600px;
            margin: 40px auto;
            background: white;
            border-radius: 20px;
            overflow: hidden;
            box-shadow: 0 20px 60px rgba(0,0,0,0.1);
        }
        .header {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            padding: 40px 30px;
            text-align: center;
            color: white;
            position: relative;
            overflow: hidden;
        }
        .header::before {
            content: '';
            position: absolute;
            top: -50%;
            left: -50%;
            width: 200%;
            height: 200%;
            background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="honeycomb" x="0" y="0" width="10" height="10" patternUnits="userSpaceOnUse"><polygon points="5,1 9,3 9,7 5,9 1,7 1,3" fill="none" stroke="rgba(255,255,255,0.1)" stroke-width="0.5"/></pattern></defs><rect width="100" height="100" fill="url(%23honeycomb)"/></svg>');
            opacity: 0.3;
            animation: float 6s ease-in-out infinite;
        }
        @keyframes float {
            0%, 100% { transform: translateY(0px) rotate(0deg); }
            50% { transform: translateY(-10px) rotate(2deg); }
        }
        .logo {
            font-size: 32px;
            font-weight: bold;
            margin-bottom: 10px;
            position: relative;
            z-index: 1;
        }
        .tagline {
            font-size: 16px;
            opacity: 0.9;
            position: relative;
            z-index: 1;
        }
        .content {
            padding: 40px 30px;
            line-height: 1.6;
        }
        .welcome-title {
            font-size: 28px;
            color: #333;
            margin-bottom: 20px;
            text-align: center;
        }
        .welcome-text {
            font-size: 16px;
            color: #666;
            margin-bottom: 30px;
            text-align: center;
        }
        .features {
            display: flex;
            justify-content: space-around;
            margin: 30px 0;
            flex-wrap: wrap;
        }
        .feature {
            text-align: center;
            flex: 1;
            min-width: 150px;
            margin: 10px;
        }
        .feature-icon {
            font-size: 40px;
            margin-bottom: 10px;
        }
        .feature-title {
            font-weight: bold;
            color: #333;
            margin-bottom: 5px;
        }
        .feature-desc {
            font-size: 14px;
            color: #666;
        }
        .cta-button {
            display: inline-block;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
            padding: 15px 30px;
            text-decoration: none;
            border-radius: 50px;
            font-weight: bold;
            margin: 20px auto;
            text-align: center;
            display: block;
            max-width: 200px;
            transition: transform 0.3s ease;
        }
        .cta-button:hover {
            transform: translateY(-2px);
            box-shadow: 0 10px 30px rgba(102, 126, 234, 0.3);
        }
        .footer {
            background: #f8f9fa;
            padding: 30px;
            text-align: center;
            font-size: 14px;
            color: #666;
            border-top: 1px solid #eee;
        }
        .social-links {
            margin: 20px 0;
        }
        .social-links a {
            display: inline-block;
            margin: 0 10px;
            color: #667eea;
            text-decoration: none;
        }
        @media (max-width: 600px) {
            .container { margin: 10px; border-radius: 15px; }
            .header { padding: 30px 20px; }
            .content { padding: 30px 20px; }
            .features { flex-direction: column; }
            .feature { margin: 15px 0; }
        }
    </style>
</head>
<body>
    <div class="container">
        <div class="header">
            <div class="logo">🐝 EventToBee</div>
            <div class="tagline">Votre plateforme d'espaces événementiels</div>
        </div>

        <div class="content">
            <h2 class="welcome-title">Bienvenue ${userName} ! 🎉</h2>

            <p class="welcome-text">
                Nous sommes ravis de vous accueillir dans la communauté EventToBee !
                Découvrez des espaces uniques pour tous vos événements.
            </p>

            <div class="features">
                <div class="feature">
                    <div class="feature-icon">🏠</div>
                    <div class="feature-title">Espaces Uniques</div>
                    <div class="feature-desc">Lofts, jardins, salles, boutiques...</div>
                </div>
                <div class="feature">
                    <div class="feature-icon">⚡</div>
                    <div class="feature-title">Réservation Rapide</div>
                    <div class="feature-desc">En quelques clics seulement</div>
                </div>
                <div class="feature">
                    <div class="feature-icon">💝</div>
                    <div class="feature-title">Prix Transparents</div>
                    <div class="feature-desc">Aucun frais caché</div>
                </div>
            </div>

            <a href="${loginUrl}" class="cta-button">
                🚀 Commencer l'exploration
            </a>

            <p style="text-align: center; color: #666; margin-top: 30px;">
                <strong>Prêt à créer des événements mémorables ?</strong><br>
                Explorez notre sélection d'espaces soigneusement choisis dans toute la France.
            </p>
        </div>

        <div class="footer">
            <div class="social-links">
                <a href="#">📘 Facebook</a>
                <a href="#">📸 Instagram</a>
                <a href="#">🐦 Twitter</a>
                <a href="#">💼 LinkedIn</a>
            </div>

            <p>
                <strong>EventToBee</strong> - La ruche des espaces événementiels 🐝<br>
                Paris & Île-de-France<br>
                <a href="mailto:contact@eventtobee.com" style="color: #667eea;">contact@eventtobee.com</a>
            </p>

            <p style="font-size: 12px; color: #999; margin-top: 20px;">
                Vous recevez cet email car vous vous êtes inscrit sur EventToBee.<br>
                <a href="#" style="color: #667eea;">Se désabonner</a> |
                <a href="#" style="color: #667eea;">Gérer mes préférences</a>
            </p>
        </div>
    </div>
</body>
</html>`;

  return (
    <div>
      <h3 className="text-lg font-semibold mb-4">📧 Template: Email de Bienvenue</h3>
      <div className="mb-4">
        <button
          className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
          onClick={() => navigator.clipboard.writeText(templateHTML)}
        >
          📋 Copier le code HTML
        </button>
      </div>
      <div className="border rounded-lg p-4 bg-gray-50" dangerouslySetInnerHTML={{ __html: templateHTML }} />
    </div>
  );
};

export default WelcomeTemplate;
